document.querySelectorAll("button[data-dialog-toggle]").forEach(function (button) {
	const dialog = document.querySelector("#" + button.getAttribute("data-dialog-toggle"));
	const dialogVideo = dialog.querySelector("video");

	if (typeof dialog.showModal !== "function") {
		return false;
	}

	button.removeAttribute("hidden");
	button.addEventListener("click", function () {
		dialog.showModal();

		document.documentElement.setAttribute("data-overlay", "open");

		if (dialogVideo) {
			dialogVideo.play();
		}
	});

	dialogVideo.addEventListener("pause", function () {
		// dialog.close();
	});

	dialog.addEventListener("close", function () {
		document.documentElement.setAttribute("data-overlay", "closed");

		if (dialogVideo) {
			dialogVideo.pause();
		}
	});
});
